import { useSelector } from "react-redux";

const useRoleCheck = (rolePermission) => {
  const { userInfo } = useSelector((state) => state.authLogin);
  // console.log("userInfo", userInfo);
  return userInfo.rolePermission === rolePermission;
};

export default useRoleCheck;
